import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  content: {
    flex: 1,
    overflow: 'auto',
    padding: '24px',
    backgroundColor: '#f8f9fa',
  },
  splitLayout: {
    display: 'flex',
    gap: '24px',
    height: 'calc(100vh - 320px)',
  },
  formPanel: {
    flex: '1 1 0',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    overflow: 'hidden',
    overflowY: 'auto',
  },
  formPanelBody: {
    flex: 1,
    overflow: 'auto',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  mappedPanel: {
    flex: '1 1 0',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    overflow: 'hidden',
  },
  mappedPanelHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
    borderBottom: '1px solid #e0e0e0',
  },
  mappedPanelBody: {
    flex: 1,
    overflow: 'auto',
    padding: '12px 16px',
  },
  mappedPanelFooter: {
    display: 'flex',
    gap: '8px',
    padding: '12px 16px',
    borderTop: '1px solid #e0e0e0',
  },
  panelTitle: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#1a1a1a',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  panelDesc: {
    fontSize: '12px',
    color: '#757575',
    marginTop: '4px',
  },
  mappedCount: {
    backgroundColor: '#e8eaf6',
    color: '#3f51b5',
    borderRadius: '12px',
    padding: '2px 8px',
    fontSize: '12px',
    fontWeight: 600,
  },
  dropdownContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  dropdownLabel: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#1a1a1a',
    marginBottom: '4px',
  },
  addButtonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '4px',
  },

  mappingChipHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '8px 16px',
    borderBottom: '1px solid #f0f0f0',
    fontSize: '11px',
    fontWeight: 600,
    color: '#757575',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  chipHeaderCheck: {
    width: '24px',
    flexShrink: 0,
  },
  chipHeaderAttr: {
    flex: 1,
    minWidth: 0,
  },
  chipHeaderArrow: {
    width: '20px',
    flexShrink: 0,
  },
  mappingChip: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '8px 0',
    borderBottom: '1px solid #f0f0f0',
    '&:last-child': { borderBottom: 'none' },
  },
  mappingChipSelected: {
    backgroundColor: '#f5f5ff',
  },
  chipAttr: {
    flex: 1,
    minWidth: 0,
    fontSize: '14px',
    color: '#1a1a1a',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 16px',
    gap: '8px',
  },
  emptyStateText: {
    fontSize: '13px',
    color: '#9e9e9e',
  },
  deleteSelectedButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    background: 'none',
    border: '1px solid #dc3545',
    borderRadius: '4px',
    padding: '4px 10px',
    fontSize: '12px',
    cursor: 'pointer',
    color: '#dc3545',
    '&:hover': { backgroundColor: '#f8d7da' },
  },
  selectAllBtn: {
    background: 'none',
    border: '1px solid #d0d0d0',
    borderRadius: '4px',
    padding: '4px 10px',
    fontSize: '12px',
    cursor: 'pointer',
    color: '#1a1a1a',
    '&:hover': { backgroundColor: '#f0f0f0' },
  },
  clearAllBtn: {
    background: 'none',
    border: '1px solid #d0d0d0',
    borderRadius: '4px',
    padding: '4px 10px',
    fontSize: '12px',
    cursor: 'pointer',
    color: '#757575',
    '&:hover': { backgroundColor: '#f0f0f0' },
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    padding: '16px 24px',
    borderTop: '2px solid #e0e0e0',
    backgroundColor: '#fafafa',
    flexShrink: 0,
  },
  loader: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  alertBanner: {
    width: 'fit-content',
    marginLeft: 'auto',
    marginTop: '8px',
  },
  infoNote: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '0.375rem',
    padding: '0.5rem 1rem',
    backgroundColor: '#fef2f2',
    border: '1px solid #fca5a5',
    borderRadius: '999px',
    marginBottom: '1.5rem',
    marginLeft: '24px',
    width: 'fit-content',
  },
  infoIcon: {
    display: 'flex',
  },
  infoNoteText: {
    fontSize: '0.8125rem',
    color: '#dc2626',
    fontWeight: 600,
    textAlign: 'left',
  },
  saveOverlay: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: 100000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default useStyles;
